// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-j88","placeholdersHeader":"styles_placeholdersHeader__q0TvI","editorStyle":"styles_editorStyle__1jPpL","placeholdersBox":"styles_placeholdersBox__2iUvX"};